import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit, OnDestroy {
  @Input() placeholder: string | undefined;
  @Input() actionText: string | undefined;
  @Input('auto') auto!: MatAutocomplete;
  @Input() cssClass: string | undefined;
  @Output() search = new EventEmitter();

  term = new Subject<string>();

  constructor() {}

  ngOnInit(): void {
    this.term.pipe(debounceTime(300)).subscribe((text) => {
      text && text.length > 2 ? this.search.emit(text) : this.search.emit('');
    });
  }

  ngOnDestroy(): void {
    this.term.unsubscribe();
  }
}
